export default "__VITE_ASSET__d92e0b8e__"